import { makeStyles } from "@mui/styles";
import { getRGBA } from "utils/color";

const useStyles = makeStyles(() => ({
  Media: {
    height: "100%",
    width: "100%",
  },

  li: {
    lineHeight: "30px",
  },

  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    color: "black",
  },

  mainWrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "calc(100vh - 50px)",
  },

  leftWrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    width: "100%",
  },

  textContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "0.5rem",
    maxWidth: "90%",
    marginTop: "2rem",
    marginBottom: "1rem",
  },

  paperWrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    padding: "30px",
    width: "100%",
    height: "100%",
  },

  insideH1: {
    marginBottom: 15,
    fontWeight: "300",
    fontSize: "26px",
    lineHeight: "32px",
  },

  insideH4: {
    marginTop: 0,
    marginBottom: 20,
    fontWeight: "300",
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
  },

  insideBody: {
    marginTop: "24px",
    fontWeight: "normal",
    fontSize: "16px",
    lineHeight: "24px",
  },

  logoImage: {
    width: "100%",
    height: "50px",
    objectPosition: "cover",
    marginLeft: 0,
    marginRight: "auto",
  },

  formBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "8px",
    width: "80%",
  },

  accountOptions: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },

  formTitle: {
    fontFamily: "Sora",
    lineHeight: "32px",
    fontSize: "24px",
    width: "100%",
    fontWeight: "400",
    color: "#002116",
  },

  formDescription: {
    fontFamily: "Nunito",
    lineHeight: "24px",
    fontSize: "16px",
    width: "100%",
    fontWeight: "400",
    color: `${getRGBA("#0F0F1E", 0.7)}`,
  },

  linearProgress: {
    marginTop: "20px",
  },

  alert: {
    width: "100%",
    marginTop: 10,
    marginBottom: "10px",
    padding: "1px 16px 1px 16px",
  },

  footer: {
    marginTop: "auto",
    backgroundColor: "#E7EAED",
    padding: "10px 10px 15px 10px",
  },

  signupLink: {
    paddingTop: 15,
    textAlign: "center",
  },

  forgotPasswordLink: {
    paddingTop: 15,
    textAlign: "center",
  },

  acceptArea: {
    marginTop: 24,
    marginBottom: 16,
    color: "black !important",
  },

  passwordDirections: {
    fontSize: "12px",
    color: "#707974",
    paddingLeft: 4,
  },

  authorizationBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "0.25rem",
    width: "100%",
    height: "100%",
    maxHeight: "20rem",
    overflowY: "auto",
  },
}));

export { useStyles };
